import { countryArr } from "@/assets/js/country";
import { nationArr } from "@/assets/js/nation";
import { languageArr } from "@/assets/js/language";
import { teacher_sign_info_view } from '@/api/training_teacher/api'
import { debug } from "util";
const HOST = process.env.VUE_APP_URL;
const levelDict = {
      '0': 'A',
      'A': 'B',
      'B': 'C',
      'C': 'D',
      'D': 'E',
      'E': '',
      'L3': 'L2',
      'L2': 'L1',
      'L1': 'early',
      'early': 'early_assistant',
      'early_assistant': '',

      'GD': 'GD',
      'GC': 'GC',
      'GB': 'GB',
      'GA': 'GA',
    }

export default {
  data() {
    
    const gender = [
      {
        key: "男",
        val: "Male"
      },
      {
        key: "女",
        val: "Female"
      },
    ];
    return {
      gender,
      countryArr,
      nationArr,
      languageArr,
      stuInfo: {},
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      teacher_sign_info_view({})
        .then(({ data }) => {
          if (Number(data.status) === 0) {
            let { language_list, academic_data, experience_data, experience_data_not, playing_data,studentSingnInfo, tea_level_data, tea_level_data_g, coa_level_data, teacher_honor_experience } = data.result;
            // 护照头像，身份证正反面
            studentSingnInfo.profile_picture && (this.photo = HOST + studentSingnInfo.profile_picture);
            if (studentSingnInfo.family_name_spell && !studentSingnInfo.given_name_spell) {
              this.$set(this.vitaForm, 'family_name_spell', studentSingnInfo.family_name_spell);
              this.switch_pinyin = true;
            }
            if (studentSingnInfo.family_name_spell && studentSingnInfo.given_name_spell) {
              this.spell_both = true;
            }
            if (studentSingnInfo.family_name_spell && !studentSingnInfo.given_name_spell) {
              this.spell_family = true;
            }
            if (!studentSingnInfo.family_name_spell && !studentSingnInfo.given_name_spell) {
              this.spell_none = true;
            }
            this.id_type = studentSingnInfo.id_type
            if (studentSingnInfo.info_status === 'pass') this.not_allow_change = true
            studentSingnInfo.id_card_photo_front && (this.cardFront = HOST + studentSingnInfo.id_card_photo_front);
            studentSingnInfo.id_card_photo_verso && (this.cardBack = HOST + studentSingnInfo.id_card_photo_verso);
            // 外语
            language_list.length && this.$set(this.vitaForm, "language_row", language_list);
            let english_file_list = []
            if(studentSingnInfo.english_file && studentSingnInfo.english_file_name){
              english_file_list.push({
                name: studentSingnInfo.english_file_name,
                url: studentSingnInfo.english_file,
              })
              this.vitaForm.english_file_list = english_file_list;
            }
            //  其他荣誉和经历
            teacher_honor_experience.length && this.$set(this.vitaForm, 'teacher_honor_experience', teacher_honor_experience)
            //  coa_level_data
            coa_level_data.length && this.$set(this.vitaForm, 'coa_level_data', coa_level_data)
            // 公用临时数组
            let tempArr = [];
            // 教育经历
            let academic_qualification = [];
            if (academic_data.length) {
              academic_qualification = academic_data.map((item) => {
                if(item.academic_end_date){
                  item.zhijin="N";
                }
                if (item.academic_start_date && item.academic_end_date) {
                  tempArr = [new Date(item.academic_start_date), new Date(item.academic_end_date)];
                } else {
                  tempArr = [];
                }
                const { work_certificate, work_certificate_title } = item;
                let work_certificate_list = []
                if(work_certificate && work_certificate_title) {
                  work_certificate_list.push({
                    name: work_certificate_title,
                    url: work_certificate,
                  })
                }
                return {
                  ...item,
                  time: tempArr,
                  work_certificate_list: work_certificate_list
                };
              });
            }
            // 执教经历
            let coaching_Experience = [];
            if (experience_data.length) {
              coaching_Experience = experience_data.map((item) => {
                if(item.coach_end_date){
                  item.zhijin="N";
                }
                if (item.coach_start_date && item.coach_end_date) {
                  tempArr = [new Date(item.coach_start_date), new Date(item.coach_end_date)];
                } else {
                  tempArr = [];
                }
                const { work_certificate, work_certificate_title } = item;
                let work_certificate_list = []
                if(work_certificate && work_certificate_title) {
                  work_certificate_list.push({
                    name: work_certificate_title,
                    url: work_certificate,
                  })
                }
                return {
                  ...item,
                  time: tempArr,
                  work_certificate_list: work_certificate_list
                };
              });
            }
            // 其他工作经历
            let coaching_Experience_not = [];
            if (experience_data_not.length) {
              coaching_Experience_not = experience_data_not.map((item) => {
                if(item.coach_end_date){
                  item.zhijin="N";
                }
                if(item.coach_start_date && item.coach_end_date) {
                  tempArr = [new Date(item.coach_start_date), new Date(item.coach_end_date)];
                } else {
                  tempArr = [];
                }
                const { work_certificate, work_certificate_title } = item;
                let work_certificate_list = []
                if(work_certificate && work_certificate_title) {
                  work_certificate_list.push({
                    name: work_certificate_title,
                    url: work_certificate,
                  })
                }
                return {
                  ...item,
                  time: tempArr,
                  work_certificate_list: work_certificate_list
                };
              });
            }
            // 运动经历
            let playing_experience = [];
            if (playing_data.length) {
              playing_experience = playing_data.map((item) => {
                if(item.play_end_date){
                  item.zhijin="N";
                }
                if (item.play_start_date && item.play_end_date) {
                  tempArr = [new Date(item.play_start_date), new Date(item.play_end_date)];
                } else {
                  tempArr = [];
                }
                return {
                  ...item,
                  time: tempArr,
                };
              });
            }



            //讲师级别
            if (tea_level_data.length) {
              const obj = {
                'present': (item) => { this.vitaForm.tea_present = item; },
                'previous': (item) => { this.vitaForm.tea_previous = item; },
                'special': (item) => { this.vitaForm.tea_special = item; },
              }
              tea_level_data.forEach((item) => {
                if (item.level) {
                  obj[item.level_type](item)
                } else {
                  this.vitaForm.tea_present.level = studentSingnInfo.teacher_level;
                  this.vitaForm.tea_previous.level = levelDict[this.vitaForm.tea_present.level]
                  
                }
              });
            } else {
              const { teacher_level, teacher_level_five } = studentSingnInfo;
              this.vitaForm.tea_present.level = this.isFive ? teacher_level_five : teacher_level;
              if (this.vitaForm.tea_present.level) {
                this.vitaForm.tea_previous.level = levelDict[this.vitaForm.tea_present.level]
              } else {
                console.warn('vitaForm.tea_present.level is null')
              }
            }
            // 守门员讲师级别处理
            if (tea_level_data_g.length) {
              const obj = {
                'present': (item) => { this.vitaForm.tea_present_g = item; },
                'previous': (item) => { this.vitaForm.tea_previous_g = item; },
              }
              tea_level_data_g.forEach((item) => {
                if (item.level) {
                  obj[item.level_type](item)
                } else {
                  this.vitaForm.tea_present_g.level = studentSingnInfo.teacher_level_g;
                  this.vitaForm.tea_previous_g.level = levelDict[this.vitaForm.tea_present_g.level]
                }
              });
            } else {
              const { teacher_level_g, teacher_level_five_g } = studentSingnInfo;
              console.warn('注意，这里要将5人制守门员教练的级别获取到')
              this.vitaForm.tea_present_g.level = this.isFive ? teacher_level_five_g : teacher_level_g;
              if (this.vitaForm.tea_present_g.level) {
                this.vitaForm.tea_previous_g.level = levelDict[this.vitaForm.tea_present_g.level]
              } else {
                console.warn('vitaForm.tea_present_g.level is null')
              }
            }
            if (this.isFive) {
              const { tea_present, tea_previous, tea_special } = this.vitaForm;
              tea_present.class_the_quality = 'futsal';
              tea_previous.class_the_quality = 'futsal';
              tea_special.class_the_quality = 'futsal';
              this.vitaForm = Object.assign({}, this.vitaForm, { tea_present, tea_previous, tea_special });
            }

            let mixinObj = {
              academic_qualification,
              // coaching_qualification,
              coaching_Experience,
              coaching_Experience_not,
              playing_experience,
              // coa_level_list,
              // honor_experience
              // tea_present,
              // tea_previous,
              // tea_special
            };
            let { entries } = Object;
            for (let [key, value] of entries(mixinObj)) {
              if (value.length === 0) {
                delete mixinObj[key];
              }
            }


            // 学员信息
            // const birthDay = studentSingnInfo.id_number.length == 18
            //   ? studentSingnInfo.id_number.substr(6, 4) + "-" + studentSingnInfo.id_number.substr(10, 2) + "-" + studentSingnInfo.id_number.substr(12, 2)
            //   : "--";
            const birthday = studentSingnInfo.birthday
            if (!birthday) { this.canChangeBirthday = true }
            this.noEdit = {
              gender: studentSingnInfo.gender,
              phone: studentSingnInfo.mobile_phone,
              idNum: studentSingnInfo.id_number,
            };
            this.vitaForm = {
              birthday,
              ...this.vitaForm,
              ...studentSingnInfo,
              ...mixinObj,
            };
            if(this.vitaForm.is_coach_experience_not === 0 || this.vitaForm.is_coach_experience_not === '0') {
              this.isCoachExperienceNotExit = false
            } else {
              this.isCoachExperienceNotExit = true
            }
            if (this.vitaForm.coach_experience === '无') {
              this.isCoachExperienceExit = false;
              this.vitaForm.coach_experience = '无'
            } else {
              if (this.vitaForm.coach_experience) {
                 try {
                    this.vitaForm.coach_experience = JSON.parse(this.vitaForm.coach_experience)
                  } catch( err ) {
                    console.log('JSON parse function is error for vitaForm.take_place:', this.vitaForm.coach_experience)
                    this.vitaForm.coach_experience = [];
                  }
              }
            };
            if (this.vitaForm.take_place === '无') {
              this.isTackPalceExit = false;
              this.vitaForm.take_place = '无'
            } else {
              if(this.vitaForm.take_place) {
                  try {
                    this.vitaForm.take_place =  JSON.parse(this.vitaForm.take_place)
                  } catch( err ) {
                    console.log('JSON parse function is error for vitaForm.take_place:', this.vitaForm.take_place)
                    this.vitaForm.take_place = [];
                  }
              }
            };
            if(this.vitaForm.sport_experience_new === '无足球运动经历') {
              this.isSportExperienceExit = false;
              this.vitaForm.sport_experience_new = '无足球运动经历'
            } ;
            // this.vitaForm.coach_experience = this.vitaForm.coach_experience ? JSON.parse(this.vitaForm.coach_experience) : '';
            // this.vitaForm.take_place = this.vitaForm.take_place ? JSON.parse(this.vitaForm.take_place) : '';
            // this.vitaForm.sport_experience = this.vitaForm.sport_experience ? JSON.parse(this.vitaForm.sport_experience) : '';
            this.isLoading = false;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
  }
}
